var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row living-options"},[_c('card-tabs',{staticClass:"col-12 w-100",attrs:{"tabs":[{ 
      label: 'Masterplan',
      id: 'masterplan',
    }, { 
      label: 'Releases',
      id: 'subsections',
    },{ 
      label: 'Lots',
      id: 'properties',
    },{ 
      label: 'Houses',
      id: 'dwellings',
    },{
      label: 'Packages',
      id: 'packages',
    }],"active-tab":_vm.activeTab},on:{"tabClick":_vm.navigateToTab},scopedSlots:_vm._u([{key:"masterplan",fn:function(){return [_c('LivingOptionsMasterplan')]},proxy:true},{key:"subsections",fn:function(){return [_c('LivingOptionsSubsections')]},proxy:true},{key:"properties",fn:function(){return [_c('LivingOptionsProperties')]},proxy:true},{key:"dwellings",fn:function(){return [_c('LivingOptionsDwellings')]},proxy:true},{key:"packages",fn:function(){return [_c('LivingOptionsPackages')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }